/**
 * Analisi del rischio
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 3.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import {Inject, Injectable, Optional} from '@angular/core';
import {HttpClient, HttpEvent, HttpHeaders, HttpParams, HttpResponse} from '@angular/common/http';
import {CustomHttpUrlEncodingCodec} from '../encoder';

import {Observable} from 'rxjs';

import {SuccessfulResponseDashboardDTO} from '../model/successfulResponseDashboardDTO';

import {BASE_PATH} from '../variables';
import {Configuration} from '../configuration';


@Injectable()
export class ReportisticaControllerService {

	protected basePath = 'http://localhost:5003';
	public defaultHeaders = new HttpHeaders();
	public configuration = new Configuration();

	constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
		if (basePath) {
			this.basePath = basePath;
		}
		if (configuration) {
			this.configuration = configuration;
			this.basePath = basePath || configuration.basePath || this.basePath;
		}
	}

	/**
	 * @param consumes string[] mime-types
	 * @return true: consumes contains 'multipart/form-data', false: otherwise
	 */
	private canConsumeForm(consumes: string[]): boolean {
		const form = 'multipart/form-data';
		for (const consume of consumes) {
			if (form === consume) {
				return true;
			}
		}
		return false;
	}


	/**
	 * Effettua il get della dashboard dell&#x27;analisi con codice {codice}
	 *
	 * @param codiceAnalisi
	 * @param widgets Lista dei widgets da scaricare
	 * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
	 * @param reportProgress flag to report request and response progress.
	 */
	public getDashboardAnalisi(codiceAnalisi: string, widgets: Array<string>, observe?: 'body', reportProgress?: boolean): Observable<SuccessfulResponseDashboardDTO>;
	public getDashboardAnalisi(codiceAnalisi: string, widgets: Array<string>, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SuccessfulResponseDashboardDTO>>;
	public getDashboardAnalisi(codiceAnalisi: string, widgets: Array<string>, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SuccessfulResponseDashboardDTO>>;
	public getDashboardAnalisi(codiceAnalisi: string, widgets: Array<string>, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

		if (codiceAnalisi === null || codiceAnalisi === undefined) {
			throw new Error('Required parameter codiceAnalisi was null or undefined when calling getDashboardAnalisi.');
		}

		if (widgets === null || widgets === undefined) {
			throw new Error('Required parameter widgets was null or undefined when calling getDashboardAnalisi.');
		}

		let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
		if (widgets) {
			widgets.forEach((element) => {
				queryParameters = queryParameters.append('widgets', <any>element);
			})
		}

		let headers = this.defaultHeaders;

		// authentication (bearerAuth) required
		if (this.configuration.accessToken) {
			const accessToken = typeof this.configuration.accessToken === 'function'
				? this.configuration.accessToken()
				: this.configuration.accessToken;
			headers = headers.set('Authorization', 'Bearer ' + accessToken);
		}
		// to determine the Accept header
		let httpHeaderAccepts: string[] = [
			'application/json'
		];
		const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
		if (httpHeaderAcceptSelected != undefined) {
			headers = headers.set('Accept', httpHeaderAcceptSelected);
		}

		// to determine the Content-Type header
		const consumes: string[] = [];

		return this.httpClient.request<SuccessfulResponseDashboardDTO>('get', `${this.basePath}/api/v1/reportistica/${encodeURIComponent(String(codiceAnalisi))}/dashboard`,
			{
				params: queryParameters,
				withCredentials: this.configuration.withCredentials,
				headers: headers,
				observe: observe,
				reportProgress: reportProgress
			}
		);
	}

}
